import React from 'react';
import { t } from 'i18n';

import Icon from 'Components/Base/Icon';

const i18nOpts = { scope: 'place_contacts.admin_panel.form' };

const VisibilityCheckbox = ({ checked, someSelected }) => {
  if (someSelected) {
    return (
      <Icon
        name="box-partial"
        className="checkbox checkbox--partial"
      />
    );
  }

  if (checked) {
    return (
      <Icon
        name="box-checked"
        className="checkbox checkbox--checked"
      />
    );
  }

  return (
    <Icon
      name="box-empty"
      className="checkbox checkbox--unchecked"
    />
  );
};

const VisibilityRow = ({ checked, someSelected, label, pill, onClick }) => (
  <div
    className="visibility_row"
    onClick={onClick}
    role="checkbox"
    aria-checked={someSelected ? 'mixed' : checked}
    tabIndex={0}
    onKeyDown={(event) => {
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        onClick();
      }
    }}
  >
    <VisibilityCheckbox checked={checked} someSelected={someSelected} />
    <span className="row_label">{label}</span>
    {pill && <span className="pill">{pill}</span>}
  </div>
);

const VisibilitySelect = ({ visibility, setVisibility, yourHealthTeamName }) => {
  const {
    patientsAndSupportTeams = false,
    yourHealthTeam = false,
    invitedHealthTeams = false,
  } = visibility || {};

  const healthTeamsAllSelected = yourHealthTeam && invitedHealthTeams;
  const healthTeamsSomeSelected = (yourHealthTeam || invitedHealthTeams) && !healthTeamsAllSelected;

  const everyoneAllSelected = patientsAndSupportTeams && yourHealthTeam && invitedHealthTeams;
  const everyoneSomeSelected = (patientsAndSupportTeams || yourHealthTeam || invitedHealthTeams) && !everyoneAllSelected;

  const updateField = (key, value) => {
    setVisibility({ ...visibility, [key]: value });
  };

  const toggleEveryone = () => {
    // we are flipping all selections to true or false
    // depending whether all were selected or not
    setVisibility({
      ...visibility,
      patientsAndSupportTeams: !everyoneAllSelected,
      yourHealthTeam: !everyoneAllSelected,
      invitedHealthTeams: !everyoneAllSelected,
    });
  };

  const toggleHealthTeams = () => {
    // we are flipping all team selections to true or false
    // depending whether all were selected or not
    setVisibility({
      ...visibility,
      yourHealthTeam: !healthTeamsAllSelected,
      invitedHealthTeams: !healthTeamsAllSelected,
    });
  };

  let yourHealthTeamLabel = t('your_health_team', i18nOpts);
  // safe way to add it so we don't crash for no reason
  if (yourHealthTeamName) { yourHealthTeamLabel += ` (${yourHealthTeamName})`; }
    

  return (
    <div className="visibility_select">
      <h4 className="visibility_heading">
        {t('visibility_heading', i18nOpts)}
      </h4>

      <VisibilityRow
        checked={everyoneAllSelected}
        someSelected={everyoneSomeSelected}
        label={t('everyone', i18nOpts)}
        pill={t('default_pill', i18nOpts)}
        onClick={toggleEveryone}
      />

      <div className="nested">
        <VisibilityRow
          checked={patientsAndSupportTeams}
          label={t('patients_and_support_teams', i18nOpts)}
          onClick={() =>
            updateField('patientsAndSupportTeams', !patientsAndSupportTeams)
          }
        />

        <VisibilityRow
          checked={healthTeamsAllSelected}
          someSelected={healthTeamsSomeSelected}
          label={t('health_teams', i18nOpts)}
          onClick={toggleHealthTeams}
        />

        <div className="nested">
          <VisibilityRow
            checked={yourHealthTeam}
            label={yourHealthTeamLabel}
            onClick={() => updateField('yourHealthTeam', !yourHealthTeam)}
          />
          <VisibilityRow
            checked={invitedHealthTeams}
            label={t('invited_health_teams', i18nOpts)}
            onClick={() => updateField('invitedHealthTeams', !invitedHealthTeams)}
          />
        </div>
      </div>
    </div>
  );
};

export default VisibilitySelect;
